import CategoryCollectionPage from './CategoryCollectionPage';
import { DONICZKOWE_CONFIG } from './categoryPageConfigs';
export default function KwiatyDoniczkowe() {
  return <CategoryCollectionPage config={DONICZKOWE_CONFIG} />;
}
